import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-trip-order-creator',
  templateUrl: './trip-order-creator.component.html',
  styleUrls: ['./trip-order-creator.component.scss']
})
export class TripOrderCreatorComponent {

  step = 1
  totalSteps = 5

  // initialize forms for each section of the work order
  customerForm: FormGroup
  shipperForm: FormGroup
  consigneeForm: FormGroup
  defaultServiceChargeForm: FormGroup;
  loadForm: FormGroup
  serviceChargesShipper: FormGroup[] = [];
  serviceChargesConsignee: FormGroup[] = [];
  palletSets: FormGroup[] = []

    // Define type list arrays for the mat-selects:
    typeListRateMethod: string[] = [
      "Cubic Feet",
      "Weight",
      "Linear Feet"
    ]
  
    typeListService: string[] = [
      "Accessorial Service",
      "Surcharge Service",
      "Tradeshow Service",
      "Trailer Build Service",
      "Customs Service",
      "Delivery Service",
      "Pickup Service",
      "Labourer Service"
    ]
  
    typeListOrderScope: string[] = [
      "Tradeshow",
      "Storage",
      "Trailer Build",
      "Warehouse",
      "Household",
      "Plug Play",
      "Blanketed",
      "Dock to Dock",
      "White Glove",
      "Military Site",
      "Extraction",
      "Disposal",
      "Job Site"
    ]
  
    typeListEquipmentType: string[] = [
      "V - Van",
      "R - Refrigerated Carrier (Reefer)",
      "F - Flatbed",
      "TWOF - Two 24 or 28 foot Flats",
      "ANIM - Animal Carrier",
      "ANYE - Any Equipment",
      "AUTO - Auto carrier",
      "B_TR - B-Train/Supertrain",
      "BDMP - Belly Dump",
      "BEAM - Beam",
      "BELT - Conveyor Belt",
      "BOAT - Boat Hauling Trailer",
      "CH - Convertible Hopper",
      "CONG - Conestoga",
      "CONT - Container Trailer",
      "CV - Curtain Van",
      "DA - Drive Away",
      "DD - Double Drop",
      "DDE - Double Drop Extendable",
      "DUMPT - Dump Trucks",
      "ENDP - End Dump",
      "FA - FlatBed - Air-Ride",
      "FEXT - Stretch Trailers or Extendable",
      "FINT - Flatbed Intermodal",
      "FO - Flatbed Over-Dimension Loads",
      "FSD - Flat or Step Deck",
      "FSDV - Flatbed, Step Deck, or Van",
      "FV - Van or Flatbed",
      "FVR - Flatbed, Van, or Reefer",
      "FVV - Flatbed or Vented Van",
      "FVVR - Flatbed, Vented Van, or Reefer",
      "FWS - Flatbed With Sides",
      "HOPP - Hopper Bottom",
      "HS - Hot Shot",
      "HTOW - Haul and Tow Unit",
      "LAF - Landoll Flatbed",
      "LB - Lowboy",
      "LBO - Lowboy over-dimension load",
      "LDOT - Load-Out are empty trailers you load and haul",
      "LIVE - Live Bottom Trailer",
      "MAXI - Maxi or Double Flat Traillers",
      "MBHM - Mobile Home",
      "PNEU - Pneumatic",
      "PO - Power Only (tow-away)",
      "RFV - Flatbed, Van, or Reefer",
      "RGN - Removable Goose Neck & Multi-Axle Heavy Haulers",
      "RGNE - RGN Extendable",
      "RINT - Refrigerated Intermodal",
      "ROLL - ROLL Top Conestoga",
      "RPD - Refrigerated Carrier W/Plant Decking",
      "RV - Van or Reefer",
      "RVF - Flatbed, Van, or Reefer",
      "SD - Step Deck",
      "SDE - Step Deck Extendable",
      "SDL - Step Deck w/Loading Ramps",
      "SDO - Step Deck over-dimension load",
      "SDRG - Step Deck or RemovableGooseneck",
      "SPEC - Unspecified Specialized",
      "HCV - High Cube Van",
      "ST - Straight Truck",
      "TANK - Tanker",
      "V_OT - Open Top Van",
      "VA - Van - Air-Ride",
      "VB - Blanket Wrap Van",
      "VCAR - Cargo Vans (1 Ton capacity)",
      "VF - Flatbed or Van",
      "VFR - Flatbed, Van, or Reefer",
      "VINT - Van Intermodal",
      "VIV - Vented Insulated Van",
      "VIVR - Vented Insulated Van or Refrigerated",
      "VLG - Van w/Liftgate",
      "VM - Moving Van",
      "VR - Van or Reefer",
      "VRDD - Van, Reefer Double Drop",
      "VRF - Flatbed, Van, or Reefer",
      "VV - Vented Van",
      "VVR - Vented Van or Refrigerated",
      "WALK - Walking Floor Odometer"
    ]
  
    typeListEquipmentOptions: string[] = [
      "Tarps",
      "Hazardous",
      "PalletExchange",
      "Team",
      "Tilt Load Lift Equipment",
      "Expedited",
      "Bonded",
      "Power Tailgate",
      "Spot/Drop Trailer",
      "Mult-Stop",
      "Blanket Wrap",
      "Temperature Control",
      "Air Ride",
      "Satellite Tracking",
      "Heated",
      "Lumper/Swamper",
      "Tradeshow"
    ]
  
    typeListPartialFull: string[] = [
      "Partial",
      "Full"
    ]
  
    typeListAccessorial: string[] = [
      "Barge Service",
      "Beyond Charge",
      "Bulky Article",
      "Cartage",
      "Change In terms of Pay",
      "Container Lift Crane",
      "Correct BOL Charge",
      "Courier",
      "Crossdock",
      "DDP Charges",
      "Dangerous Goods",
      "Detention",
      "Disposal Fee",
      "Drayage",
      "Exclusive Use",
      "Expedite",
      "Export Shipping Charge",
      "Extraction",
      "Facility Fee",
      "Forklift",
      "Haz Mat",
      "Heated Service",
      "Inspection Fee",
      "Inward Charge",
      "Layover",
      "Linehaul Inbound",
      "Linehaul Outbound",
      "Linehaul",
      "Linked Expense",
      "Loading",
      "Maintenance",
      "Marking Tagging",
      "Materials",
      "Minimum Charge",
      "Off Line Miles",
      "Over The Road",
      "Pallet Allowance",
      "Redirect",
      "Refused",
      "Return To Shipper",
      "Reworking Freight",
      "Scale Ticket",
      "Scrap Yard Fees",
      "Segregation Charge",
      "Service Charge",
      "Single Shipment",
      "Site Inspection",
      "Skid Fee",
      "Skid Wrapping",
      "Sortation Charge",
      "Stair Crawler",
      "Stop Off",
      "Storage In Transit",
      "Supplies",
      "Tarping",
      "Team Service",
      "Tilt Load Lift Equipment",
      "Tolls",
      "Trailer Drop",
      "Trailer Repair",
      "Trailer Shunt",
      "Trailer Storage",
      "Truck Furnished Not Used",
      "Truck Overflow",
      "Unloading",
      "Waiting Overtime",
      "Waiting Time",
      "Weight Inspection Fee",
      "White Glove Service"
    ]
  
    typeListSurcharge: string[] = [
      "Delivery Surcharge",
      "Carbon Surcharge",
      "Haz Mat Surcharge",
      "Fuel Surcharge LTL",
      "Fuel Surcharge TL",
      "Fuel Surcharge Flat",
      "Non Conveyable Surcharge",
      "Fuel Surcharge",
      "Pan Am Games",
      "Service Surcharge"
    ]
  
    typeListTradeshow: string[] = [
      "Tradeshow Adminstration",
      "Tradeshow Delivery",
      "Tradeshow Pickup"
    ]
  
    typeListTrailerBuild: string[] = [
      "Build Cleaning",
      "Build Consulting",
      "Build Contruction",
      "Build Cover Storage",
      "Build Delivery",
      "Build Detention",
      "Build GPS",
      "Build License Plates",
      "Build Maintenance",
      "Build Material",
      "Build Missed Pickup",
      "Build Nets",
      "Build Permit",
      "Build Purchase",
      "Build Repair",
      "Build Shelf Covers",
      "Build Shunt",
      "Build Storage",
      "Build Truck Wash",
      "Build Waiting Time",
      "Build Wrap"
    ]
  
    typeListCustoms: string[] = [
      "Border Delay",
      "Border Security",
      "Border Crossing",
      "Bond Charge",
      "Bond with Re-Delivery",
      "Customs Detention",
      "Customs Devanning",
      "Customs Brokerage",
      "Customs Exam",
      "Duty"
    ]
  
    typeListDelivery: string[] = [
      "Delivery After Hours",
      "Delivery Appointment",
      "Delivery Detention",
      "Delivery Rate",
      "Delivery Extra",
      "Delivery Inside",
      "Re-Delivery",
      "Delivery Residential",
      "Delivery Tailgate",
      "Delivery Weekend",
      "Delivery Notification",
      "Delivery Straight Truck",
      "Delivery Time Specific",
      "Delivery Date Time Specific",
      "Split Delivery",
      "Delivery Downtown",
      "Delivery Highcost Area",
      "Delivery Limited Access",
      "Delivery Attempted",
      "Delivery Advance Hours",
      "Delivery Certified",
      "Delivery Back Door"
    ]
  
    typeListPickup: string[] = [
      "Pickup After Hours",
      "Pickup Extra",
      "Pickup Missed",
      "Pickup Tailgate",
      "Pickup Weekend",
      "Pickup Straight Truck",
      "Pickup Detention",
      "Pickup Origin",
      "Pickup Residential",
      "Pickup Single Shipment",
      "Pickup Rate",
      "Pickup Extra",
      "Pickup Inside",
      "Pickup Certified",
      "Pickup Time Specific",
      "Pickup Date Time Specific"
    ]
  
    typeListLabourer: string[] = [
      "Helper",
      "Helper Overtime",
      "Crew Leader",
      "Labour",
      "Warehouse Labour",
      "Lumper Handling",
      "Labour Mileage",
      "Driver Assist"
    ]

  constructor(private formBuilder: FormBuilder) {

    // build form for the customer section
    this.customerForm = this.formBuilder.group({
      customer_company_name: ['', Validators.required],
      customer_address: ['', Validators.required],
      customer_shipping_bol: [''],
      customer_invoice_bol: '',
      customer_invoice_pod_required: '',
      customer_invoice_po_required: '',
      customer_rate_quote: '',
      customer_consignee_agreement: '',
      customer_at_pickup_notification: '',
      customer_delayed_pickup_notification: '',
      customer_at_delivery_notification: '',
      customer_delayed_delivery_notification: '',
      customer_assessorials_incurred_notification: '',
      customer_csa: '',
      customer_fast: '',
      customer_ace: '',
      customer_aci: '',
      customer_ct_pat: '',
      customer_canada_bond: '',
      customer_us_bond: '',
      customer_hazmat: '',
      customer_protect_from_freezing: '',
      customer_heated: '',
      customer_refrigeration: '',
      customer_food_grade: '',
      rate_method: ['', Validators.required],
      bill_to_company_name: ['', Validators.required],
      bill_to_address: ['', Validators.required],
    })

    // build form for the shipper section
    this.shipperForm = this.formBuilder.group({
      shipper_company_name: ['', Validators.required],
      shipper_address: ['', Validators.required],
      shipper_loading_dock: '',
      shipper_pickup_tailgate: '',
      shipper_truck_space: '',
      shipper_pickup_straight_truck: '',
      shipper_bol_required: '',
      shipper_pickup_reference: '',
      estimated_date_shipper: '',
      estimated_time_start_shipper: '',
      shipper_is_residential: '',
      shipper_is_commercial: '',
      shipper_is_job_site: '',
      shipper_lift_lull: '',
      shipper_call_site: '',
      shipper_unmanned_job_site: '',
      shipper_job_site_contact_name: '',
      shipper_job_site_contact_phone: '',
      shipper_is_convention_center: '',
      shipper_is_pop_up: '',
      appointment_shipper: '',
      appointment_date_shipper: '',
      appointment_time_start_shipper: '',
      appointment_time_end_shipper: '',
    })

    // build form for the consignee section
    this.consigneeForm = this.formBuilder.group({
      consignee_company_name: ['', Validators.required],
      consignee_address: ['', Validators.required],
      consignee_loading_dock: '',
      consignee_pickup_tailgate: '',
      consignee_truck_space: '',
      consignee_pickup_straight_truck: '',
      consignee_bol_required: '',
      consignee_delivery_reference: '',
      estimated_date_consignee: '',
      estimated_time_start_consignee: '',
      consignee_is_residential: '',
      consignee_is_commercial: '',
      consignee_is_job_site: '',
      consignee_lift_lull: '',
      consignee_call_site: '',
      consignee_unmanned_job_site: '',
      consignee_job_site_contact_name: '',
      consignee_is_convention_center: '',
      consignee_is_pop_up: '',
      appointment_consignee: '',
      appointment_date_consignee: '',
      appointment_time_start_consignee: '',
      appointment_time_end_consignee: ''
    })

    // build form for the default service section
    this.defaultServiceChargeForm = this.formBuilder.group({
      shipper_service_charge_service: ['', Validators.required],
      shipper_service_charge_service_type: ['', Validators.required],
    })

    // build form for the load
    this.loadForm = this.formBuilder.group({
      order_scope: ['', Validators.required],
      order_scope_secondary: ['', Validators.required],
      operations_notation: ['', Validators.required],
      num_pallets: '',
      length: '',
      width: '',
      height: '',
      weight: ''
    })

    // build form for the pallet sets
    const palletSetFormGroup = this.formBuilder.group({
      num_pallets: '',
      length: '',
      width: '',
      height: '',
      weight: ''
    });

    this.palletSets.push(palletSetFormGroup);

  }

  addServiceCharge(form: string) {
    const serviceChargeFormGroup = this.formBuilder.group({
      service: ['', Validators.required],
      service_type: ['', Validators.required],
    });

    if (form === 'shipper') {
      this.serviceChargesShipper.push(serviceChargeFormGroup);
    } else {
      this.serviceChargesConsignee.push(serviceChargeFormGroup);
    }
  }

  // Deletes the service charge at specific index when user clicks remove service charge
  removeServiceCharge(index: number, form: string) {
    if (form === 'shipper') {
      this.serviceChargesShipper.splice(index, 1);
    } else {
      this.serviceChargesConsignee.splice(index, 1);
    }
  }

  // Function to return which country has been selected to determine which typeList array to use (province or states)
  getService(service: string): string[] {
    if (service === 'Accessorial Service') {
      return this.typeListAccessorial;
    } else if (service === 'Service Program') {
      return this.typeListService;
    } else if (service === 'Surcharge Service') {
      return this.typeListSurcharge;
    } else if (service === 'Tradeshow Service') {
      return this.typeListTradeshow;
    } else if (service === 'Trailer Build Service') {
      return this.typeListTrailerBuild;
    } else if (service === 'Customs Service') {
      return this.typeListCustoms;
    } else if (service === 'Delivery Service') {
      return this.typeListDelivery;
    } else if (service === 'Pickup Service') {
      return this.typeListPickup;
    } else if (service === 'Labourer Service') {
      return this.typeListLabourer;
    } else {
      return [];
    }
  }

  // Event handler for changing the address country and setting appropriate province/state to the address_region in the form
  onServiceChange(index: number, form: string) {
    let serviceFormGroup: FormGroup | undefined
    if (form === 'shipper') {
      serviceFormGroup = this.serviceChargesShipper.at(index);
    } else {
      serviceFormGroup = this.serviceChargesConsignee.at(index);
    }
    const serviceControl = serviceFormGroup?.get('service');
    const serviceTypeControl = serviceFormGroup?.get('service_type');
    const serviceTypes = this.getService(serviceControl?.value);
    serviceTypeControl?.setValue(null);
    serviceTypeControl?.setValidators(serviceTypes.length > 0 ? Validators.required : null);
    serviceTypeControl?.updateValueAndValidity();
  }

  // Pushes new pallet set form to the group of pallet sets
  addPalletSet() {
    const palletSetFormGroup = this.formBuilder.group({
      num_pallets: '',
      length: '',
      width: '',
      height: '',
      weight: ''
    });

    this.palletSets.push(palletSetFormGroup);
  }

  // Deletes the pallet set at specific index when user clicks remove pallet sets
  removePalletSet(index: number) {

    this.palletSets.splice(index, 1);

  }

  nextStep() {
    if (this.step < this.totalSteps) {
      this.step++;
    }
  }

  // Move back to the previous step in the form
  prevStep() {
    if (this.step > 1) {
      this.step--;
    }
  }

  // Change step to the step relative to the icon on the progress bar clicked on
  changeStep(newStep: number) {
    this.step = newStep;
  }
}
